<script setup lang="ts">
import { useAttrs } from 'vue'

const attrs$ = useAttrs()
</script>

<template>
  <div class="def:md:bg-black text-center def:md:py-40 def:md:px-30" v-bind="attrs$">
    <slot name="header"></slot>
    <slot name="subheader"></slot>
    <slot name="content"></slot>
  </div>
</template>
